import { LOCALE_ID, NgModule, provideNgReflectAttributes } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouteReuseStrategy } from "@angular/router";
import { ServiceWorkerModule } from "@angular/service-worker";
import { EDatabaseRole } from "@calaosoft/osapp-common/store/models/edatabase-role";
import { ChangelogsModule } from "@calaosoft/osapp-mobile/modules/about/changelogs/changelogs.module";
import { BatteryModule } from "@calaosoft/osapp-mobile/modules/battery/battery.module";
import { BTSModule } from "@calaosoft/osapp-mobile/modules/bts/bts.module";
import { AddBtsMissingColumnsPatch } from "@calaosoft/osapp-mobile/modules/bts/patches/add-bts-missing-columns.patch";
import { MigrateBTSStoragePatch } from "@calaosoft/osapp-mobile/modules/bts/patches/migrate-bts-storage.patch";
import { IDatabaseGroupingConfiguration } from "@calaosoft/osapp-mobile/modules/database-synchro/model/IDatabaseGroupingConfiguration";
import {
	DATABASES_GROUPING_CONFIG,
	DMS_SYNC_CONFIG
} from "@calaosoft/osapp-mobile/modules/database-synchro/services/database-synchro.service";
import { FormModule } from "@calaosoft/osapp-mobile/modules/forms/form/form.module";
import { BarcodeReaderConfigService } from "@calaosoft/osapp-mobile/modules/logistics/barcode-reader/services/barcode-reader-config.service";
import { UpdateCatalogPatch } from "@calaosoft/osapp-mobile/modules/logistics/catalog/patches/update-catalog-patch";
import { LogisticsWithoutRoutingModule } from "@calaosoft/osapp-mobile/modules/logistics/logistics-without-routing.module";
import { LogisticsModule } from "@calaosoft/osapp-mobile/modules/logistics/logistics.module";
import { ReasonService } from "@calaosoft/osapp-mobile/modules/logistics/reason/services/reason.service";
import { RemoveInvalidStocksPatch } from "@calaosoft/osapp-mobile/modules/logistics/stock/patches/remove-invalid-stocks-patch";
import { StockModule } from "@calaosoft/osapp-mobile/modules/logistics/stock/stock.module";
import { PatchModule } from "@calaosoft/osapp-mobile/modules/patch/patch.module";
import { RoutingModule } from "@calaosoft/osapp-mobile/modules/routing/routing.module";
import { SqlModule } from "@calaosoft/osapp-mobile/modules/sqlite/sql.module";
import { ToastModule } from "@calaosoft/osapp-mobile/modules/toast/toast.module";
import { OsappModule } from "@calaosoft/osapp-mobile/osapp.module";
import { Capacitor } from "@capacitor/core";
import { IonicModule, IonicRouteStrategy } from "@ionic/angular";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { ProvisioningService } from "./appointment/services/provisioning.service";
import { CustomerContactsModule } from "./customer-contacts/customer-contacts.module";
import { MerchDmsModule } from "./dms/merch-dms.module";
import { MerchStatsService } from "./task/counting/services/merch-stats.service";
import { MerchReasonService } from "./task/returns/services/merch-reason.service";
import { MerchReturnRackService } from "./task/returns/services/merch-return-rack.service";
import { MerchReturnsService } from "./task/returns/services/merch-returns.service";
import { MerchBarcodeReaderConfigService } from "./task/services/merch-barcode-reader-config.service";

const databasesGroupingConfigs: IDatabaseGroupingConfiguration[] = [
	{
		roles: [EDatabaseRole.workspace, EDatabaseRole.userContext],
		title: "Espace de travail",
		description: "tournées, tâches"
	}
];

@NgModule({
	declarations: [AppComponent],
	imports: [
		BrowserAnimationsModule,
		IonicModule.forRoot({ innerHTMLTemplatesEnabled: true }),
		AppRoutingModule,
		FormsModule,
		ReactiveFormsModule,
		OsappModule,
		PatchModule.forRoot([AddBtsMissingColumnsPatch, UpdateCatalogPatch, RemoveInvalidStocksPatch, MigrateBTSStoragePatch]),
		MerchDmsModule,
		LogisticsWithoutRoutingModule,
		SqlModule,
		BatteryModule,
		ChangelogsModule,
		ServiceWorkerModule.register("ngsw-worker.js", {
			enabled: ["web"].includes(Capacitor.getPlatform()),
			registrationStrategy: "registerImmediately"
		}),
		LogisticsModule,
		RoutingModule,
		StockModule,
		FormModule,
		ToastModule,
		BTSModule,
		CustomerContactsModule
	],
	providers: [
		// Réactive les attributs ng-reflect-* (mode dev uniquement, supprimés par défaut depuis Angular 20)
		// le temps que les assertions des tests e2e qui s'appuient dessus soient réécrites.
		provideNgReflectAttributes(),
		{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
		{ provide: LOCALE_ID, useValue: "fr-FR" },
		{ provide: DATABASES_GROUPING_CONFIG, useValue: databasesGroupingConfigs },
		{ provide: DMS_SYNC_CONFIG, useValue: { title: "Documents", description: "photos, ..." } },
		MerchBarcodeReaderConfigService,
		{ provide: BarcodeReaderConfigService, useClass: MerchBarcodeReaderConfigService },
		AddBtsMissingColumnsPatch,
		UpdateCatalogPatch,
		RemoveInvalidStocksPatch,
		MigrateBTSStoragePatch,
		MerchReturnsService,
		ReasonService,
		MerchReturnRackService,
		MerchReasonService,
		ProvisioningService,
		MerchStatsService
	],
	bootstrap: [AppComponent]
})
export class AppModule {}
